<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="项目投资名称">
          <el-input placeholder="请输入项目投资名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加项目投资</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="项目投资名称"></el-table-column>
            
            <!-- 添加状态列 -->
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag 
                  :type="scope.row.status === 1 ? 'success' : (scope.row.status === 2 ? 'danger' : 'warning')"
                  size="small"
                >
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 根据状态显示不同的操作按钮 -->
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button 
                  v-if="scope.row.status === 0" 
                  @click="auditClick(scope.row)" 
                  type="text" 
                  size="small"
                   class="member-btn"
                >
                  审核
                     <span v-if="scope.row.is_read == 0" class="unread-dot-member"></span>
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" :supply_id="supply_id" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :project_investment_id="project_investment_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!-- 审核对话框 -->
    <el-dialog
      title="项目投资审核"
      :visible.sync="auditDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="项目名称">
          <span>{{ currentProject.name }}</span>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核意见" v-if="auditForm.status === 2">
          <el-input
            type="textarea"
            v-model="auditForm.remark"
            placeholder="请输入审核不通过的原因"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog 
      style="text-align: center" 
      title="设置标题" 
      :visible.sync="dialogVisible" 
      @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
  import Project_investmentApi from '@/api/project_investment.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import SupplyApi from '@/api/supply.js';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search: ""
        },
        supply_id: '',
        open_add: false,
        open_edit: false,
        project_investment_id: "",
        dialogVisible: false,
        
        /* 审核相关数据 */
        auditDialogVisible: false,
        currentProject: {},
        auditForm: {
          status: 1,
          remark: ''
        }
      };
    },
    created() {
      this.supply_id = this.$route.query.supply_id;
      /*获取列表*/
      this.getTableList();
    },

    methods: {
      /* 获取状态文本 */
      getStatusText(status) {
        const statusMap = {
          0: '未审核',
          1: '审核通过',
          2: '未通过'
        };
        return statusMap[status] || '未知状态';
      },
      
      /* 打开审核对话框 */
      auditClick(row) {
        this.currentProject = { ...row };
        this.auditForm = {
          status: 1,
          remark: ''
        };
        this.auditDialogVisible = true;
      },
      
      /* 提交审核 */
      submitAudit() {
        if (this.auditForm.status === 2 && !this.auditForm.remark.trim()) {
          this.$message.error('请填写审核不通过的原因');
          return;
        }
        
        Project_investmentApi.audit({
          project_investment_id: this.currentProject.project_investment_id,
          status: this.auditForm.status,
          remark: this.auditForm.remark
        }, true)
        .then(data => {
          if (data.code == 1) {
            this.$message({
              message: '审核成功',
              type: 'success'
            });
            this.auditDialogVisible = false;
            this.getTableList();
          } else {
            this.$message.error(data.msg || '审核失败');
          }
        })
        .catch(error => {
          this.$message.error('审核失败');
        });
      },
      
      dialogFormVisible() {
        this.dialogVisible = false;
      },
      setting(e) { //项目投资标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e) {
        this.open_add = false;
        this.getTableList();
      },
      closeEdit(e) {
        this.open_edit = false;
        this.getTableList();
      },
      getData() {
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.supply_id = self.supply_id
        Params.list_rows = self.pageSize;
        self.loading = true;
        Project_investmentApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.project_investment_id = row.project_investment_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Project_investmentApi.del(
              {
                project_investment_id: row.project_investment_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style>
  /* 可以根据需要添加样式 */
  .member-btn {
  position: relative;
}

/* 会员未读红点样式 */
.unread-dot-member {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ff4757;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/project_investment/index/index.vue